import { type GetBoardStatsResponse } from '@air/api';
import { formatBytes } from '@air/utilities';
import pluralize from 'pluralize';

export const formatBoardStats = (stats: GetBoardStatsResponse) => {
  const statsArray = [];

  if (stats.subBoardCount) {
    statsArray.push(pluralize('sub-board', stats.subBoardCount, true));
  }

  if (stats.assetCount) {
    statsArray.push(pluralize('asset', stats.assetCount, true));
  }

  if (stats.fileCount) {
    statsArray.push(pluralize('file', stats.fileCount, true));
  }

  if (stats.sizeBytes) {
    statsArray.push(formatBytes(stats.sizeBytes));
  }

  return statsArray;
};
